import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { ProductResponse } from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/products`);

/**
 * Products API client.
 */
export const productsClient = {
  /**
   * Get avaliable products details.
   */
  list: async () => client.get<ProductResponse>(''),
};
